import Flag from '../../src/legacy/Flag';
export default Flag;
